const shippingsModel = vm => ({
  title: vm.$gettext('Shippings'),
  endpoint: 'shippings',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'company_id',
      sortable: false,
      label: vm.$gettext('Posted by'),
      formatter: (value, key, item) => {
        return item.company ? item.company.name : ''
      }
    },
    {
      key: 'from_address',
      sortable: false,
      label: vm.$gettext('Origin')
    },
    {
      key: 'last_known_place.formatted_address',
      sortable: false,
      label: vm.$gettext('Last Known Place')
    },
    {
      key: 'to_address',
      sortable: false,
      label: vm.$gettext('Destination')
    },
    {
      key: 'instructions',
      sortable: true,
      label: vm.$gettext('Instruct.')
    },
    {
      key: 'scheduled_date',
      sortable: true,
      label: vm.$gettext('Sched. At')
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      sortable: true
    },
    {
      key: 'courier',
      sortable: false,
      label: vm.$gettext('Courier')
    },
    {
      key: 'courier_commission',
      sortable: false,
      label: vm.$gettext('Comm.')
    },
    {
      key: 'size_id',
      sortable: false,
      label: vm.$gettext('Size')
    },
    {
      key: 'shipping_type_id',
      sortable: false,
      label: vm.$gettext('Type')
    },
    {
      key: 'sla_date',
      sortable: true,
      label: vm.$gettext('SLA')
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At'),
      sortable: true
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true
    }
  ],
  filters: [
    'id',
    'from_place_id',
    'from_contact',
    'address_from.formatted_address',
    'from_email',
    'from_phone',
    'to_contact',
    'address_to.formatted_address',
    'to_email',
    'to_phone',
    'status',
    'scheduled_date',
    'created_at',
    'updated_at',
    'user_id',
    'company_id',
    'shipping_type_id',
    'tour_id',
    'sla_date'
  ],
  includes: [
    'courier.courier_available.tracking',
    'courier_company',
    'company',
    'user',
    'status_history',
    'pending_hooks',
    'tags',
    'threads',
    'previousShipping',
    'followingShippings',
    'items',
    'from_area',
    'to_area',
    'deliveryTimeRange',
    'last_known_place'
  ],
  highPerformanceIncludes: ['last_known_place']
})

export default shippingsModel
